import { Component, inject } from '@angular/core'
import { ActivatedRoute, Params } from '@angular/router'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { LoginFormComponent } from '@account/Components/Auth/Login/Form/LoginForm.Component'
import { TwoFactorChallengeComponent } from '@account/Components/Auth/Login/Form/TwoFactorChallenge.Component'

@Component({
	selector: 'login-component',
	templateUrl: './Login.Component.html',
	styleUrls: ['../Auth.css'],
	imports: [
		CardComponent,
		CardContentComponent,
		LoginFormComponent,
		TwoFactorChallengeComponent,
	],
})
export class LoginComponent {
	public showChallenge = false

	private redirectEndpoint: string | null = null

	private readonly route: ActivatedRoute

	constructor() {
		this.route = inject(ActivatedRoute)

		this.route.queryParams.subscribe((params: Params): void => {
			this.redirectEndpoint = params.redirect
				? `${params.redirect}`
				: '/my-account'
		})
	}

	public displayChallengeScreen = () => {
		this.showChallenge = true
	}

	public redirect = () => {
		window.location.href = this.redirectEndpoint
	}
}
